// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1xram","label":"Labeled_label__cPwgE","divider":"Labeled_divider__3WO3p"};